import { Global, Modal } from '@mantine/core';
import { EntityType } from '@repo/common/enums/entityType';
import { Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { usePreventNavigation } from '../../hooks/usePreventNavigation';
import { openConfirmModal } from '../ModalManager';
import { ENTITY_TYPES_MODAL_CONFIG } from './constants';
import EntityModalFooter from './Footer/EntityModalFooter';
import EntityModalHeader from './Header/EntityModalHeader';
import EntityModalMetadata from './Metadata/EntityModalMetadata';
import { MetadataHeader } from './Metadata/MetadataHeader';
import { entityModalStore } from './store';

function EntityModal() {
	const { opened, description, template, title, type } = entityModalStore;

	const templateRichTextValue =
		type &&
		template?.[
			ENTITY_TYPES_MODAL_CONFIG[type].richTextTemplateField ?? 'definition'
		];

	// We want to prevent showing the unsaved changes modal for questions
	const isQuestion = type === EntityType.question;

	const shouldPreventClosing =
		opened &&
		!isQuestion &&
		(description?.length > 4 || title?.length > 4) &&
		(!template || description !== templateRichTextValue);

	usePreventNavigation(shouldPreventClosing);

	const handleOnClose = () => {
		if (shouldPreventClosing) {
			openConfirmModal({
				title: 'You have unsaved changes',
				children: (
					<Text size="sm">
						You'll lose your changes if you close this dialog. Are you sure you
						wish to close?
					</Text>
				),
				labels: { confirm: 'Confirm', cancel: 'Cancel' },
				onConfirm: () => entityModalStore.reset(),
			});
		} else {
			entityModalStore.reset();
		}
	};

	return (
		<Modal
			opened={entityModalStore.opened}
			onClose={handleOnClose}
			title={<MetadataHeader />}
			size="xl"
			closeButtonProps={{
				'aria-label': 'Close modal',
			}}
			centered
		>
			<Global
				styles={() => ({
					'.heading-actions, .block-menu-trigger': {
						display: 'none !important',
					},
				})}
			/>
			<EntityModalHeader />
			<EntityModalMetadata type={entityModalStore.type} />
			<EntityModalFooter type={entityModalStore.type} />
		</Modal>
	);
}

const EntityModalObserver = observer(EntityModal);
export default EntityModalObserver;
